import React, { useEffect, useRef, useState } from "react";
import "./TextReveal.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import bulb1 from "../assets/bulb1.png";
import bulb2 from "../assets/bulb2.png";

function TextReveal() {
  const [letterRef, setLetterRef] = useArrayRef();
  const [glowText, setGlowText] = useState(
    "Click on the bulb to turn off dark mode"
  );
  const [isDarkMode, setIsDarkMode] = useState(false);
  function useArrayRef() {
    const lettersRef = useRef([]);
    lettersRef.current = [];
    return [lettersRef, (ref) => ref && letterRef.current.push(ref)];
  }
  const triggerRef = useRef(null);
  gsap.registerPlugin(ScrollTrigger);

  useEffect(() => {
    const reveal = gsap.to(letterRef.current, {
      scrollTrigger: {
        trigger: triggerRef.current,
        scrub: true,
        start: "top center",
        end: "bottom 90%",
      },
      color: "#352F8F",
      duration: 1,
      stagger: 1,
    });
    if (isDarkMode) {
      document.body.style.backgroundColor = "white";
      document.body.style.color = "black"; // Optional: restores text color
    } else {
      document.body.style.backgroundColor = "black";
      document.body.style.color = "white"; // Optional: changes text color to white for better readability
    }

    // Cleanup function to reset background color when component unmounts or changes
    return () => {
      document.body.style.backgroundColor = "";
      document.body.style.color = ""; // Reset to default colors
    };
  }, [isDarkMode]);
  const text = "Empowering your business with innovation and security.";
  const [imgSrc, setImgSrc] = useState(bulb1); // Initial image source
  const [isGreen, setIsGreen] = useState(false);

  const toggleImage = () => {
    setImgSrc((prevSrc) => {
      const newSrc = prevSrc === bulb1 ? bulb2 : bulb1;
      setGlowText(
        newSrc === bulb1
          ? "Click on the bulb to turn off dark mode"
          : "Click on the bulb to turn onn dark mode"
      );
      setIsGreen(newSrc === bulb2);
      setIsDarkMode(newSrc === bulb2);
      return newSrc;
    });
  };
  return (
    <>
      {/* <h2 style={{backgroundColor:'#F5EDED'}} className="font-manrope text-5xl text-center font-bold text-gray-900 pt-2">
            About Us
          </h2> */}

      <div
        className={`spacing-small ${isDarkMode ? "bg-default" : "bg-black"}`}
      ></div>
      <div
        className={`flex flex-col-reverse w-[80%] mx-auto md:flex-row items-center ${
          isDarkMode ? "bg-default" : "bg-black"
        }`}
      >

        <div className="md:w-1/2 flex justify-center md:justify-start items-center">
          <div className="reveal" ref={triggerRef}>
            {text.split("").map((letter, index) => (
              <span className="reveal-text" ref={setLetterRef} key={index}>
                {letter}
              </span>
            ))}
          </div>
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center items-center">
          <img src={imgSrc} alt="Bulb Image" onClick={toggleImage} />
          <p
            className={`mt-2 text-center ${
              isGreen ? "bg-gray-300" : "default"
            }`}
          >
            {glowText}
          </p>
        </div>
      </div>
      <div
        className={`spacing-small ${isDarkMode ? "bg-default" : "bg-black"}`}
      ></div>
    </>
  );
}

export default TextReveal;